import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StarInvisibleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 8.468L3.69 8.814C3.24 8.849 3.06 9.403 3.4 9.692L7.26 12.993C7.54 13.237 7.67 13.62 7.58 13.985L6.4 18.921C6.3 19.353 6.77 19.695 7.15 19.464L11.48 16.818C11.8 16.623 12.2 16.623 12.52 16.818L16.85 19.464C17.23 19.695 17.7 19.353 17.6 18.921L17.24 17.412M10.69 5.146L11.54 3.11C11.71 2.699 12.29 2.699 12.46 3.11L14.41 7.795C14.55 8.142 14.88 8.378 15.25 8.408L20.31 8.814C20.76 8.849 20.94 9.403 20.6 9.692L17.75 12.131M4.5 4.5L19.5 19.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

StarInvisibleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(StarInvisibleIcon);
